export let poMessages={
  "privacy_policy_and_terms_of_use":"Privacy Policy and Terms of Use ",
  "privacy_confirm_text":"We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",
  "privacy_confirm_disagree":"Disagree",
  "privacy_confirm_accept":"Accept",

  "title":"EasyView Personal",
  "title1":"EasyView Pro",
  "user":"Email",
  "password":"Palavra-passe",
  "remember":"Lembrar de mim",
  "forget":"Esqueceu-se da sua palavra-chave?",
  "sign in":"Entrar",
  "login":"Login",
  "sign up now":"Regisrar-se agora",
  "apply":"Aplicar agora",
  "contact us":"Contacte Nós",
  "Privacy Policy":"Política de Privacidade",
  "Terms of Use":"Termos de Uso",
  "copyright":"Copyright © 2021 Medtrum Technologies Inc. Todos direitos reservados.",

  "chooseLang":"Escolha seu país ou sua língua",
  "asia":"Ásia",
  "europe":"Europa",

  "applyHcp":"Aplicar por uma conta de médico",
  "sign up":"Registrar-se",
  "Patient":"Paciente",
  "Caregiver":"Cuidador",
  "Email":"Email",
  "Mobile":"Telemóvel",
  "Enter email":"Insira o endereço de Email",
  "Enter mobile":"Insira o telemóvel",
  "Verification":"Código de Verificação",
  "Invitation":"Invitation code",
  "full name":"Insira seu nome completo",
  "Enter pass":"Insira palava-passe",
  "org":"Organização",
  "Register":"Registrar-se",
  "send":"Enviar",
  "agree":"Eu li e aceito a ",
  "privacy":" política de privacidade  ",
  "and" :"e os ",
  "use":"temos de serviço.",
  "errtip1-1":"Você precisa inserir um endereço de email válido,",
  "errtip1-2":"na qual será seu nome de usuário Medtrum",
  "errtip2":"Please enter a valid mobile number.",
  "errtip3":"Código de Verificação Incorreto",
  "errtip4":"Incorrect invitation code.",
  "errtip5":"Usuário Incorreto",
  "errtip6":"Your password must have 8 or more characters.",
  "errtip7":"Por favor insira sua organização.",

  "errp1":"A palavra-passe precisa conter pelo menos 3 tipos dos seguintes caracteres:",
  "errp2":"letra maíuscula, letra minúscula, número e um caractere especial",
  "errp3":"A palavra-passe precisa ter entre 6 a 20 caracteres ",
  "errp4":"A palavra-passe precisa ser diferente do nome de usuário",
  "errp5":"A palavra-passe com 3 números consecutivos é inválida (ex: 123, 321).",
  "errp6":"A palavra-passe com 3 letras consecutivas é inválida (ex: abc, cba).",
  "errp7":"A palavra-passe não pode conter espaços.",


  "Find account":"Recupere sua palavra-passe",
  "Enter username":"Por favor insira seu nome de usuário",
  "Next":"Próximo",
  "Cancel":"Cancelar",
  "Back":"Voltar",
  "Enter veri":"Código de Verificação",
  "Verify notice":"Por favor encontre o código de verificação enviado ao seu email",
  "Create new":"Criar uma nova palavra-passe",
  "Create new notice":"Por favor crie uma nova palavra-passe, e sua palavra-passe precisa conter 6 ou mais caracteres",
  "New pass" :"Nova Palavra-passe",
  "Completed":"Completado",
  "Created":"Nova Palavra-passe criada",
  "Login Now":"Registrar-se agora",

  "Delete":"Deletar",
  "New Patient":"New Patient",
  "Add Patient":"Adicionar Paciente",
  "Filter":"Filtrar",
  "Name":"Nome",
  "Gender":"Gênero",
  "Age":"Idade",
  "Type":"Tipo",
  "Duration":"Duration",
  "Connections":"Criador de Contas",
  "UploadTime":"Tempo de Carregamento",
  "Year":"anos",
  "Years":"Anos",
  "Month":"mês",
  "Month2":"Mês",
  "Months":"mês",
  "Invite":"Convidar",
  "Invited":"Convidado",
  "All":"Todos",
  "Female":"Feminino ",
  "Male":"Masculino",
  "Not Set":"Não especificado",
  "Type 1":"Tipo 1",
  "Type 2":"Tipo 2",
  "Gestational":"Gestacional",
  "Prediabetes":"Pré-Diabetes",
  "LADA":"Tipo 1.5 LADA",
  "Apply":"Aplicar",
  "disUn":"Tipo de Diabetes não especificado",
  "ageUn":"Idade não especificada",
  "genUn":"Género não especificado",
  "addP":"Adicionar Paciente",
  "newP":"Novo Paciente",
  "findP":"Encontrar Paciente",

  "GDRNF":"Não especificado",
  "GDRF":"Feminino ",
  "GDRM":"Masculino",
  "女":"Masculino",

  "DBTNF":"Não especificado",
  "DBT1":"Tipo 1",
  "DBT2":"Tipo 2",
  "DBTLADA":"Tipo 1.5 LADA",
  "DBTPRE":"Pré-Diabetes",
  "DBTGEST":"Gestacional",
  "前期":"beFore",
  "beFore":"beFore",
  "MODY":"Mody",

  "No selection":"Não especificado",
  "unspecif":"Não especificado",
  "register":"Paciente",
  "hcp":"Clínico",

  "BG":"GS",
  "CARB":"Carboidratos",
  "INS":"Injeção",
  "EXR":"Exercício",
  "OTR":"Outros",
  "HBA1C":"HbA1c",
  "DOSE":"DOSE",
  "URINEK":"Cetona na Urina",
  "HEL":"HEL",
  "OTR1":"Outros",
  "Loading":"A Carregar",

  "home":"Início",
  "pID":"ID do Paciente",
  "fullName":"Nome completo",
  "gender":"Gênero",
  "height":"Altura",
  "weight":"Peso",
  "cm":"cm",
  "kg":"kg",
  "birthday":"Data de nascimento",
  "disType":"Tipo de diabetes",
  "disDate":"Data do diagnóstico",
  "Address":"Endereço",
  "Postcode":"Código Postal",
  "Inpatient":"Paciente Internado",
  "Yes":"Sim",
  "No":"Não",
  "Pno":"Número do Paciente",
  "Bno":"Número da Cama",
  "create":"Criar",
  "Telephone":"Telefone",

  "enterU":"Insira nome de usuário (email)",
  "search":"Buscar",
  "noU":"Nome do usuário é necessário",
  "searchR":"Resultados da Busca",
  "uername":"Nome de usuário",
  "alias":"pseudônimo",
  "remove":"Remover",
  "viewG":"Visualizar gráficos",
  "sendR":"Enviar Pedido",
  "rSent":"Seu pedido foi enviado",
  "cancelR":"Cancelar requisição",

  "VcodeTip1":"Não recebeu? Por favor espere por um minuto e ",
  "VcodeTip2":"tente novamente.",
  "VcodeTip3":"Nós acabamos de enviar um código de verificação para ",
  "Entercode":"Inserir código",
  "Getcode":"Pegar código",

  "messages":"Mensagens",
  "profile":"Perfil",
  "sign out":"Sair",
  "changeP":"Alterar palavra-passe",
  "connection":"Conexões",

  "myP":"Meu perfil",
  "Portrait":"Foto do perfil",
  "Profession":"Profissão",
  "DPRONF":"Não especificado",
  "DPROENDOCRIN":"Endocrinologista",
  "DPRODIABTRA":"Educador de Diabetes",
  "DPRONURSE":"Enfermeiro",
  "DPRODIATIT":"Nutricionista",
  "DPROOTR":"Outros Médicos",
  "Organization":"Organização",
  "Bio":"Bio",
  "save":"Salvar",
  "oldPa":"Palavra-passe antiga",
  "newPa":"Nova Palavra-passe",
  "RePa":"Reinsira a palavra-passe",
  "forgetY":"Esqueceu a palavra-passe?",
  "applyM":"Aplicar",
  "oldErr":"A antiga palavra passe está incorreta",
  "EntTheSame":"Insira a nova palavra passe novamente",
  "EnterOld":"Insira a antiga palavra passe",

  "pList":"Lista de Paciente",
  "connections":"Conexões",
  "settings":"Configurações",
  "monitor":"Monitorar",
  "graphs":"Relatórios",
  "events":"Eventos",
  "records":"Registros",
  "qPrint":"Imprimir rápido",

  "sensorIn":"Informação do Sensor",
  "timeOfLaRead":"Hora da última leitura do sensor",
  "tranSn":"NS do Transmissor",
  "status":"Estado",
  "sensorLife":"Vida do Sensor Restante",
  "lastSenorRead":"Última leitura do sensor",
  "TranBattery":"Bateria do Transmissor",
  "sg":"SG",
  "alert":"Alerta",
  "target":"Alvo",
  "hypo":"Hipoglicemia",
  "sensorGlucose":"Sensor de Glicose",
  "calib":"Calibração",
  "newSen":"Novo Sensor",
  "warm":"Aquecendo",
  "InsulinPump":"Bomba de Insulina",
  "timeOfLaPump":"Hora do último dado da bomba",
  "pumpSN":"NS da Bomba Base",
  "ReserviorLife":"Vida do Reservatório Patch restante",
  "InsulinLeft":"Insulina Restante",
  "basal":"Basal",
  "bolus":"Bolus",
  "totalBasal":"Total diário basal",
  "lastBolus":"Último bolus",
  "activeInsulin":"Insulina Ativa",
  "totalBolus":"Total diário bolus",
  "tampBasal":"Basal Temporário",
  "normalBolus":"Bolus Normal",
  "extendBolus":"Bolus de Onda Quadrada",
  "manualStop":"Suspensão Manual",
  "autoStop":"Suspensão Automática",
  "auto suspend":"Suspensão Automática",
  "stop":"Entrega suspensa",
  "newPatch":"Novo Patch",
  "tempBasal":"Basal Temporário",
  "N":"N",
  "E":"E",
  "CN1":"CN",
  "CE":"CE",

  "staticSettings":"Configurações do Relatório",
  "dataSource":"Fonte de Dados",
  "unit":"Unidade",
  "glucoseTarget":"Intervalo de Glicose Alvo",
  "overall":"No total",
  "Hypoglycemia":"Hipoglicemia",
  "timePeriod":"Período de Tempo",
  "postMeal":"Análise de Pós-Refeição",
  "Breakfast":"Pequeno Almoço",
  "Lunch":"Almoço",
  "Dinner":"Janta",
  "night":"A noite",
  "Before":"Antes",
  "After":"Depois",
  "Low":"Baixo",
  "High":"Alto",
  "From":"De",
  "To":"Para",
  "Hours":"horas",
  "Reset":"Restaurar para configurações padrões",
  "RealTime":"Tempo Real",
  "uploaded":"Enviado",
  "sensor":"Sensor",
  "pdmSN":"NS do GPD",
  "startTime":"Hora de Inicio",
  "endTime":"Hora do término",
  "uploadTime":"Hora de envio",
  "pdm":"GPD",
  "Uploaded":"Enviado",
  "Patch Pump":"GPD",
  "overLapp":"Sessões sobrepostas",
  "showAlert":"Mostrar alertas",

  "dashboard":"Painel de Controlo",
  "dboard_glucose_statistics":"Estatísticas",
  "dboard_glucose":"Glicose",
  "dboard_cgm":"MCG",
  "dboard_insulin":"Insulina",
  "dboard_carbs":"Hidratos de Carbono",
  "dboard_exercise":"Exercício",
  "dboard_glucose_avg":"Média",
  "dboard_cgm_avg":"Média",
  "dboard_insulin_avg":"Dose Média Diária",
  "dboard_carbs_avg":"Ingestão Média Diária de Hidratos de Carbono Média de HC/Dia",
  "dboard_exercise_avg":"Tempo médio/dia",
  "dboard_sd":"DP",
  "dboard_num":"#",
  "dboard_num_days":"# days",
  "dboard_statistics":"Estatísticas",
  "dboard_BG":"GS",
  "dboard_BG_calibration":"GS/Calibração (por dia)",
  "dboard_SG":"GI",
  "dboard_AUC_high":"AUC max >",
  "dboard_AUC_low":"AUC min <",
  "dboard_highest_value":"Valor máximo",
  "dboard_lowest_value":"Valor mínimo",

  "dboard_pump":"Bomba",
  "dboard_avg_daily_dose":"Dose Média Diária",
  "dboard_SD":"DP",
  "dboard_daily_basal":"Basal Diário",
  "dboard_daily_bolus":"Bolus Diário",
  "dboard_avg_bolus_num":"Quant. média de bolus por dia ",
  "dboard_avg_suspend_time":"Tempo Médio de Suspensão",
  "dboard_avg_reservoir_usage":"Utilização Média do Reservatório",
  "dboard_days":"days",

  "dboard_manual_bolus":"Bolus Manual (Volume/quant. diária)",
  "dboard_normal":"-Normal",
  "dboard_extend":"-Alargado",
  "dboard_combo":"-Combinação",

  "dboard_bolus_calculator":"Cálculo de Bolus (Volume/quant. diária)",
  "dboard_food_bolus":"-Calc. bolus alim.",
  "dboard_corr_bolus":"-Calc. bolus corr.",
  "dboard_override_add":"-Sobrepor(+)",
  "dboard_override_sub":"-Sobrepor(-)",

  "dboard_report":"Painel de Controlo Relatório",

  "daily":"Resumo Diário",
  "date":"Data",
  "print":"Imprimir",
  "carbs":"Hidratos de Carbono",
  "exercise":"Exercício",
  "heavy":"Pesado",
  "Medium":"Médio",
  "Light":"Leve",
  "dailyReport":"Relatório do Resumo Diário",
  "devices":"Dispositivos",
  "tran":"Transmissor",
  "pumpBase":"Bomba Base",
  "HbA1c":"HbA1c",
  "statics":"Estatísticas",
  "glucose":"Glicose",
  "item":"Artigo",
  "BG1":"GS",
  "SG1":"GS",
  "avgSD":"Med (mmol/L) ± DP",
  "avgSD1":"Med ± DP",
  "min":"Min",
  "max":"Max",
  "ofRead":"# de leituras",
  "ofHypo":"# de hipoglicemia/duração(min)",
  "ofAlert":"# de alertas",
  "insulin":"Insulina",
  "insulin2":"Insulina",
  "totalDose":"Dose Diária Total",
  "foodBolus":"Bolus de Comida ",
  "Food+coor":"Food+corr",
  "calibBolus":"Correção de Bolus",
  "durationStop":"Duração da suspensão(min)",
  "ofPumpAlert":"# de alertas da boma",
  "ofMeal":"# de refeições",
  "totalExerTime":"Tempo total de exercícios",
  "exerNum":"# de exercícios",
  "avgInten":"Med Intensidade",
  "target1":"Alvo",
  "high1":"Alto",
  "low1":"Baixo ",
  "BG Reading":"Leituras de GS",

  "dayByday":"Visão Geral do Dia a Dia",
  "dayBydayRe":"Relatório da Visão Geral do Dia a Dia",
  "period":"Período",

  "sensorOverlay":"Superposição do Sensor",
  "set":"Configurar",
  "setPeriod":"Configurar Período",
  "Weekdays":"Dia de semana",
  "Weekends":"Final de semana",
  "Mon":"Seg",
  "Tue":"Ter",
  "Wed":"Qua",
  "Thur":"Qui",
  "Thu":"Qui",
  "Fri":"Sex",
  "Sat":"Sab",
  "Sun":"Dom",
  "Average":"Média",
  "sensorOlRe":"Relatório da Superposição do Sensor",
  "Avg":"Med",
  "±SD":"±DP",
  "ofhypo":"# de Hipoglicemia",
  "Everyday":"Todos os dias",

  "TrendAna":"Análise de Tendência",
  "TrendRe":"Relatório de Análise de Tendência",
  "sensorGlu":"Sensor de Glicose ",
  "ofBGtest":"# de testes de GS",
  "Basics":"Báscas",
  "static":"Estatísticas",
  "Med":"Mediano",
  "med":"Mediano",
  "Q1":"Q1",
  "Q3":"Q3",
  "Q11":"Q1",
  "Q31":"Q3",
  "IQR":"IQR",
  "SD":"Desvio Padrão",
  "CV":"Coeficiente de variação",
  "SE1":"Erro Padrão da Média",
  "distri":"Distribuição",
  "stab":"Estabilidade",
  "#high":"# de alto",
  "#low":"# de baixo",
  "aucBelow":"AAC Abaixo do limite ",
  "aucAbove":"AAC Acima do limite",
  "bgRead":"Leituras de GS",
  "total":"Total",
  "ofBolus":"# de bolus",
  "avgBolus":"Média de Bolus",
  "Dura1":"Duração (min)",
  "Avg/Total":"Média/Total",
  "high":"Alto",
  "low":"Baixo",
  "#hypo":"# de Hipoglicemia",
  "ofExer":"# de Exercícios",

  "logbook":"Diário de Bordo",
  "dailyTotal":"Total Diário",
  "High Glucose":"Glicose Alta",
  "Low Glucose":"Glicose Baixa",
  "No Active Patch":"Nenhum Patch Ativo",
  "Missed Meal":"Refeição Perdida",
  "Multiple BG Readings":"Múltiplas leituras de GS",
  "Stop Patch":"Parar Patch",
  "Others":"Outros",
  "Other Events":"Outros Eventos",
  "logRe":"Relatório do Diário de Bordo",

  "DeviceSetting":"Revisão das Configurações dos Dispositivos",
  "Insulin Pump":"Bomba de Insulina",
  "MaxBasalRate":"Taxa Basal Máxima",
  "BasalPatterns":"Padrões Basais",
  "Selected Basal Pattern":"Padrão Basal Selecionado",
  "Maximum Bolus":"Bolus Máximo",
  "Combo/Extended Bolus":"Onda Dupla/ Onda Quadrada",
  "BG Reminder":"Lembrete GS",
  "Bolus Increment":"Incremento de Bolus",
  "Bolus Calculator":"Calculadora de Bolus",
  "Active Insulin Time":"Tempo de Insulina Ativa",
  "IC Ratios":"Índice IC",
  "Insulin Sensitivity":"Sensibilidade à Insulina ",
  "BG Target":"GS Alvo",
  "Bolus Reminder":"Lembrete de Bolus",
  "CGM":"MCG",
  "CGM System":"Sistema CMG",
  "Glucose Unit":"Unidade de Glicose",
  "Glucose Limits":"Limites de Glicose",
  "Predicitive Alerts":"Alertas Previsivos ",
  "Rate Alerts":"Alertas de Taxa ",
  "type":"Tipo",
  "time":"Hora",
  "data":"Dado",
  "Rate":"Rate",
  "Calibration Reminder":"Lembrete de Calibração",
  "Calibration Repeat":"Repetição de Calibração",
  "Snooze":"Soneca",
  "Audio Options":"Opções de Áudio",
  "Confidence Reminder":"Lembrete de Confiança",
  "Backlight":"Luz de fundo",
  "Sec":"seg",
  "Alarm Clock":"Despertador",
  "Patch Expiration":"Expiração do Patch",
  "Sensor Expiration":"Expiração do Sensor",
  "Hourly Max":"Max por hora",
  "Daily Max":"Max diário",
  "Low Reservoir":"Reservatório Baixo",
  "Low Suspend":"Suspensão baixa",
  "Predictive Low Suspend":"Suspensão Preditiva Baixa",
  "Rise":"Aumentar",
  "Fall":"Cair",
  "Auto Off":"Desligar Automático",
  "Standard":"Padrão",
  "Exercise":"Exercícios",
  "Holiday":"Feriado",
  "ProgramA":"Padrão A",
  "ProgramB":"Padrão B",
  "--":"--",
  "Insulin":"Insulina",

  "SUSA":"Desligar Automático",
  "SUSHM":"Excede Max 1h Entregue",
  "SUSDM":"Excede Max TDD",
  "SUSLSG":"Suspensão Baixa",
  "SUSPLSG":"Suspensão Preditiva Baixa",
  "Pump Restarted":"Bomba reiniciado",
  "Meter BG Now":"Medir GS Agora",
  "Sensor Exp in 2 Hours":"Sensor Exp em 2 horas",
  "Sensor Exp in 6 Hours":"Sensor Exp em 6 horas",
  "Sensor Exp in 30 Min":"Sensor Exp em 30 min",
  "Sensor Calibration Error":"Erro na Cal do Sensor",
  "Sensor Error":"Sem leituras",

  "Device Settings Report":"Relatório das Configurações do Dispositivo",
  "24h Total":"Total de 24h",
  "Device Settings at":"Configurações do Dispositivo em ",
  "Start":"Iniciar",
  "Combo/Ext Bolus":"Onda Dupla/ Onda Quadrada",
  "Time Format":"Formato de Hora",
  "Device Options（CGM System)":"Opções do Dispositivo (Sistema CMG)",
  "Device Options（Insulin Pump)":"Opções do Dispositivo (Bomba de Insulina)",
  "Dispay Settings (Screen)":"Configurações de exibição (tela)",
  "Dispay Settings (Backlight)":"Configurações de exibição (Luz de Fundo)",
  "Graph Range":"Faixa Gráfica",
  "Range":"Gráfica",
  "Repeat":"Repetir",
  "Glucose Alerts":"Alarmes de Glicose",
  "Alert Silence":"Alerta Silencioso",

  "Create":"Criar",
  "Event Filter":"Filtros de Eventos",
  "HbA1c1":"HbA1c",
  "Urine Ketone":"Cetona na Urina",
  "Injection":"Injeção",
  "Other":"Outros",
  "Event Type":"Tipo de Evento",
  "Details":"Detalhes",
  "Notes":"Notas",
  "Source":"Recursos",
  "edit":"Editar",
  "Action":"Ação",
  "EventReport":"Relatório do Resumo de Eventos",
  "By Date":"Por Data",
  "By Category":"Por Categora",
  "Event Summary":"Resumo de Evento",
  "No data":"Sem dados",
  "No1":"Nenhum",
  "data1":"dado",
  "#":"#",
  "BG Summary":"Resumo da GS",
  "Carbs Summary":"Resume de Carboidratos",
  "Injection Summary":"Resumo de Injeções",
  "Exercise Summary":"Resumo de Exercícios",
  "Input Notes":"Introduzir uma nota",

  "Profile":"Perfil",
  "Complications":"Complicações",
  "Concomitant diseases":"Doenças Concomitantes",
  "Suggestion":"Sugestão",
  "Coronary heart disease":"Doença cardíaca coronária",
  "High blood lipids":"Lipídios sanguíneos elevados",
  "High blood pressure":"Pressão alta",
  "Kidney disease":"Doenca renal",
  "Neuropathy":"Neuropatia",
  "Obesity":"Obesidade",
  "Peripheral arterial disease":"Doença arterial periférica",
  "Retinopathy":"Retinopatia",
  "Smoking addiction":"Fumante",
  "Enter date":"Insira data",
  "Enter suggestion":"Insira sugestão",
  "Enter Notes":"Insira nota",
  "Select":"Selecionar",
  "Prescription":"Prescrição",
  "Medicine":"Remédio",
  "Dose":"Dose",
  "Enter medicine":"Insira remédio",
  "Enter dose":"Insira dose",
  "Enterdis":"Insira Doenças Concomitantes",
  "Add note":"Adicionar nota",
  "Add Content":"O comprimento máximo é de 1000 caracteres",
  "Other suggestions":"Outras sugestões",
  "OK":"OK",
  "HCP":"Médico",
  "Content":"Conteúdo",
  "Records Report":"Relatório de Registros",

  "Quick Print":"Impressão Rápida",
  "Quick Print Settings":"Configuração de Impressão Rápida",
  "Select duration":"Selecionar duração",
  "One Week":"Uma Semana",
  "One Month":"Um Mês",
  "One Quarter":"Um Trimestre",
  "End date":"Data de término",
  "Yesterday":"Ontem",
  "Last Sunday":"Domingo Passado",
  "Last Saturday":"Sábado Passado",
  "Last Day of Last Month":"Last Day of Last Month",
  "Last Day of Last Quarter":"Last Day of Last Quarter",
  "Customized":"Customizar",
  "Week Filter":"Filtro Semanal",
  "Select reports to print":"Selecione relatórios para imprimir",
  "Daily Summary":"Resumo Diário",
  "Day By Day Overview":"Visão Geral do Dia a Dia",
  "Sensor Overlay":"Superposição do Sensor",
  "Trend Analysis":"Análise de Tendência",
  "Logbook":"Diário de Bordo",
  "Device Settings Review":"Revisão das Configurações do Dispositivo",
  "createReport":"Gerar Relatório",

  "Segment Analysis":"Análise do Período",
  "Sensor Glucose Profile":"Perfil do Sensor de Glicose",
  "# of Boluses":"# de Doses de Bolus",
  "Bolus Insulin":"Bolus de Insulina",
  "Basal Pattern":"Padrões Basais",
  "Segment Analysis Report":"Relatório de Análise de Segmentos",
  "Avg Glucose":"Média Glicose",
  "Below":"Abaixo",
  "In Target Range":"No Intervalo Objetivo",
  "Coefficient of variation":"Coeficiente de variação",
  "% Time CGM Active":"% Tempo MCG Ativo",
  "est_a1c_t1":"A1C Estimada:",
  "est_a1c_t2":"calculada com base nos valores da GI ",
  "est_a1c_t3":"Nota: Esta estimativa do nível de A1C não substitui a medição em laboratório",

  "acceptTip":" permitiu que você visualize as informações de saúde dele (a)",
  "cancelTip":" parou de permitir a visualização remota da informação de saúde dele(a). Você pode aplicar novamente se necessário.",
  "rejectTip":" rejeitou seu pedido de visualização remota",
  "Read":"Consultar",

  "Connection":"Conexão",
  "connections1":"Conexões",
  "Add Connection":"Adicionar Conexão",
  "SG":"SG",
  "Active Insulin":"Insulina Ativa",
  "Stop following":"Parar os seguintes",
  "Enter username (email)":"Insira nome de usuário (email)",
  "Search results":"Resultados da Busca",
  "Send request":"Enviar Pedido",
  "View graphs":"Visualizar gráficos",
  "Agree":"Aceitar",
  "Deny":"Rejeitar",
  "Remove":"Remover",
  "Cancel Requset":"Cancelar Pedido",
  "Remark":"Observação",

  "Warm up":"Aquecendo",
  "Monitoring":"Monitorização",
  "Transmitter Error":"Erro no Transmissor",
  "Sensor Failure":"Falha no Sensor",
  "Sensor Expired":"Sensor Expirado",
  "Lost Sensor":"Sensor Perdido",
  "Not Calibrated":"Não calibrado",
  "Calibrating":"Calibrando",
  "Calibration Needed":"Calibração Necessária",
  "Calibration Error":"Erro na Calibração",
  "Charging Battery":"Carregando Bateria",
  "Battery Charged":"Bateria Carregada",

  "To be filled":"Para ser preenchido",
  "Filled with insulin":"Preenchido com insulina",
  "Priming":"Preparando",
  "Priming completed":"Preparação completada",
  "Inserting needle":"Inserindo agulha",
  "Patch activated":"Patch ativado",
  "Delivering Basal":"Entregando Basal",
  "Exceeds Max 1 Hour Delivery":"Excede Max 1h Entregue",
  "Exceeds Max TDD":"Excede Max TDD",
  "Suspend":"Suspender",
  "Occlusion Detected":"Oclusão Detectada",
  "Patch Expired":"Patch expirado",
  "Empty Reservoir":"Reservatório Vazio",
  "Patch Error":"Erro no Patch",
  "Pump Base Error":"Erro na Bomba Base",
  "Patch Battery Depleted":"Bateria do Patch esgotada",
  "Magnetic sensor not calibrated":"Sensor magnético não calibrado",

  "Patient Profile":"Perfil do Paciente",

  "On":"Ligado",
  "on":"Ligar",
  "Off":"Desligado",
  "off":"Desligado",

  "CORONARY_HEART_DISEASE":"Doença cardíaca coronária",
  "HIGH_BLOOD_LIPIDS":"Lipídios sanguíneos elevados",
  "HIGH_BLOOD_PRESSURE":"Pressão alta",
  "KIDNEY_DISEASE":"Doenca renal",
  "NEUROPATHY":"Neuropatia",
  "OBESITY":"Obesidade",
  "PERIPHERAL_ARTERIAL_DISEASE":"Doença arterial periférica",
  "RETINOPATHY":"Retinopatia",
  "SMOKING_ADDICTION":"Fumante",

  "saveTip":"Salvo com sucesso",
  "changePaTip":"Sua palava-passa foi alterada",
  "enterEmTip":"Insira seu endereço de email",
  "verErrTip":"Código de Verificação incorreto",
  "chooseEventTip":"Selecione eventos para imprimir",
  "chooseDataTip":"Selecione dados para imprimir",
  "dateWrongTip":"A data de término não pode ser antes da data de início",
  "infoWrongTip":"Por favor preencha todos os campos necessários",
  "createdSuccssTip":"Criado com sucesso",
  "selectData":"Selecione dados para salvar",

  "acceSu":"Pedido de conexão aceitada",
  "acceEr":"Falha em adicionar uma nova conexão",
  "rejeSu":"Pedido de conexão rejeitada",
  "rejeEr":"Falha em rejeitar o pedido",

  "userNotExist":"O usuário não existe",
  "Password incorrect":"Palavra-passe incorreta",
  "UserType incorrect":"Tipo de usuário incorreto",

  "registSuccess":"Sua conta foi criada com sucesso.",
  "registFailed":"Falha ao registrar uma nova conta.",
  "sentSuccess":"Mensagem enviada com sucesso",
  "sentFailed":"Falha ao enviar mensagem",
  "Input error":"Erro de introdução",

  "deletePtip":"Você tem certeza que deseja deletar esses pacientes?",
  "deleteEvents":"Tem a certeza de que pretende eliminar estes eventos?",
  "deleteData":"Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis":"Tem a certeza de que pretende eliminar ?",
  "confirm":"Confirmar",
  "deleteSuccess":"Deletado com sucesso",
  "deleteFailed":"Falha ao deletar item",
  "modifySuccess":"Trocado com sucesso",
  "modifyFailed":"Falha ao trocar",
  "createSuccess":"Criado com sucesso",
  "createFailed":"Falha ao criar",
  "editSuccess":"Edição com sucesso",
  "editFailed":"Falha ao editar",
  "Time overlapped":"As sessões que você selecionou sobrepuseram um a outro.",

  "stopFollow":"Tem a certeza de que pretende deixar de seguir este paciente?",
  "CancelTip1":"Você tem certeza que deseja deletar essa conexão?",

  "Warning":"Avisar",
  "agreeConnect":"Se você clicar “Aceitar” para aceitar o pedido de conexão, seus dados de saúde estarão disponíveis para a nova conexão.",
  "denyConnect":"Você tem certeza que deseja rejeitar o pedido de conexão?",
  "deleteConnect":"Você tem certeza que deseja deletar essa conexão? Se você deleta-lo(a), a conexão não poderá visualizar seu dado de saúde ",

  "Choose the events to print":"Selecione eventos para imprimir",
  "tryAgain":"Tente novamente",
  "username and password is required":"username and password is required",
  "A name is required":"Um nome é necessário",
  "username is required":"Nome do usuário é",
  "The date choose wrong":"Data incorreta",
  "Date no more than 14 days":"Você não pode selecionar mais de 14 dias.",

  "CancelTip":"Você tem certeza que deseja deletar a conexão?",
  "removeConnect":"Deletado com sucesso",

  "dateErr1":"Você não pode selecionar mais de 90 dias.",
  "dateErr2":"A data de término não pode ser antes da data de início",

  "Not Filled":"Não especificado",
  "Today":"Hoje",
  "duration":"Duração",
  "interval":"Interval",
  "7 days":"7 dias",
  "14 days":"14 dias",
  "30 days":"30 dias",
  "90 days":"90 dias",
  "g":"g",

  "Sound+Vibrate":"Áudio+Vibração",
  "Sound":"Audio",
  "Vibrate":"Vibração",
  "Silent":"Modo silencioso",
  "1":"Uma vez",
  "2":"Diariamente",
  "noMes":"Não há mensagens",
  "noConnect":"Não há conexões",
  "Customize":"Customizar",
  "GB":"United Kingdom",
  "CN":"China",
  "FR":"France",
  "DD":"Germany",
  "DE":"Germany",
  "SE":"Sweden",
  "AU":"Australia",
  "HKF":"Hongkong",
  "HU":"Hungary",
  "IT":"Italy",
  "NL":"Netherlands",
  "Nor":"Norway",
  "PT":"Portugal",
  "ES":"Spain",
  "TR":"Turkey",

  "Jan":"Jan",
  "Feb":"Fev",
  "Mar":"Mar",
  "Apr":"Abr",
  "May":"Mai",
  "Jun":"Jun",
  "Jul":"Jul",
  "Aug":"Ago",
  "Sep":"Sep",
  "Oct":"Out",
  "Nov":"Nov",
  "Dec":"Dez",
  "ApplyTip":" solicitação para visualizar seus dados.",
  "noReadings":"Sem leituras",

  "daop_A6_system":"A6 Touchcare System",
  "daop_easytouch_easyview":"EasyTouch / EasyView iPad",
  "daop_TY012_TY015":"TY012/TY015",
  "daop_easysense":"EasySense",
  "daop_delete_data":"Delete Data",
  "daop_uploaded_data":"Dados Enviados",
  "daop_uploaded_data_text":"Dados provenientes da Aplicação EasyTouch ou da Aplicação EasyView, para iPad.",
  "daop_realtime_data":"Dados em Tempo Real",
  "daop_realtime_data_text":"The data is from EasySense App or EasyPatch App.",

  "ins_unit":"(U)",
  "ins_unit2":"U",
  "basal_unit":"(U/H)",
  "basal_unit2":"U/H",

  // 告警
  "Alerts_Patch_Battery_Low":"Patch com Bateria Baixa",
  "Alerts_Patch_Battery_Depleted":"Patch com Bateria Esgotada", // update
  "Alerts_Lost_Pump":"Lost Pump",
  "Alerts_Low_Reservoir":"Reservatório baixo", // update
  "Alerts_Empty_Reservoir":"Reservatório Vazio",
  "Alerts_Patch_Expiration_Advisory":"Guia de Expiração do Patch",
  "Alerts_Patch_Exp_In_1_Hour":"Patch Exp In 1 Hour",
  "Alerts_Patch_Expired":"Patch Expirado", // update
  "Alerts_Patch_Error":"Erro no Patch",
  "Alerts_Pump_Base_Error":"Erro na Bomba Base",
  "Alerts_Basal_Rate_Key_Error":"Basal Rate Key Error",
  "Alerts_Occlusion_Detected":"Oclusão Detectada", // update
  "Alerts_End_Of_Suspend":"End Of Suspend",
  "Alerts_Exceeds_Max_TDD":"Excede Max TDD", // update
  //"Alerts_Exceeds_Max_TDD":"Exceeds Max TDD",
  "Alerts_Exceeds_Max_1Hr_Delivery":"Excede Max 1h Entregue",
  //"Alerts_Exceeds_Max_1Hr_Delivery":"Exceeds Max 1Hr Delivery",
  "Alerts_Predictive_Low_Suspend":"Suspensão Preditiva Baixa", // update
  "Alerts_Low_Suspend":"Suspensão baixa",
  "Alerts_Auto_Off":"Desligar Automático", // update

  "Alerts_Pump_Restart":"Pump Restart",  // 22
  "Alerts_Auto_Off_Warning":"Auto Off Warning",  // 23
  "Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //24
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  // 25
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //33

  "Alerts_Lost_Sensor":"Sensor Perdido", // update
  "Alerts_Transmitter_Battery_Low":"Bateria Baixa do Transmissor",
  "Alerts_Charge_Transmitter":"Carregar Transmissor",
  "Alerts_Sensor_Error":"Sem leituras",
  "Alerts_Transmitter_Error":"Erro no Transmissor",
  "Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  //"Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  "Alerts_Sensor_Failure":"Falha no Sensor",
  "Alerts_Sensor_Calibration_Reminder":"Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now":"Medir GS Agora",
  "Alerts_Sensor_Exp_in_6_Hours":"Sensor Exp em 6 horas",
  "Alerts_Sensor_Exp_in_2_Hours":"Sensor Exp em 2 horas", // update
  "Alerts_Sensor_Exp_in_30_Min":"Sensor Exp em 30 min",
  "Alerts_Sensor_Expired":"Sensor expirado", // update
  "Alerts_Rapid_Rise":"Aumento Rápido",
  "Alerts_Rapid_Fall":"Queda Rápida",
  "Alerts_High_Predicted":"Alta Previsivel",
  "Alerts_Low_Predicted":"Baixa Previsivel",
  "Alerts_High_Glucose":"Alta Glicose", // update
  "Alerts_Low_Glucose":"Baixa Glicose", // update
  "Alerts_Below_3.1_mmol/L":"Inferior a 3,1 mmol/L",
  "Alerts_Transmitter_Battery_Low_2":"Bateria Baixa do Transmissor",

  "Alerts_PDM_Battery_Low":"Bateria Baixa do GPD",
  "Alerts_Replace_Battery":"Charge PDM Now", // update

  // Alert页面
  "Alert":"Alert",
  "Alerts":"Alertas",
  "Alert Filter":"Alert Filter",
  "PDM":"PDM",
  "Pump":"Bomba",
  //"CGM":"CGM",
  "Out Of Range": "Out Of Range",
  "t1221_Time_in_Auto_Mode":"Time in Auto Mode",
  "t1221_Average_SG_SD":"Average SG ± SD",
  "t1221_Time_in_Target_Range":"Time in Target Range",
  "t1221_Time_above_Range":"Time above Range",
  "t1221_Time_below_Range":"Time below Range",
  "t1221_Auto_Basal_per_day":"Auto Basal (per day)",
  "t1221_Auto_Bolus_per_day":"Auto Bolus (per day)",
  "t1221_Auto_Mode_Exits":"Auto Mode Exits",
  "t1221_No_Sensor_readings":"No Sensor readings",
  "t1221_Max_Delivery":"Max Delivery",
  "t1221_Min_Delivery":"Min Delivery",
  "t1222_autoModeBasal":"Auto Mode Basal",
  "t1222_autoModeCorrBolus":"Auto Mode Correct Bolus",
  "t1222_autoSnack":"Auto Snack",
  "t1222_autoBreakfast":"Auto Breakfast",
  "t1222_autoLunch":"Auto Lunch",
  "t1222_autoDinner":"Auto Dinner",
  "t1222_autoExercise":"Auto Exercise",
  "t1222_Snack":"Snack",
  "t1222_Auto_Mode":"Auto Mode",
  "t1222_Time_in_Auto_Mode":"Time in Auto Mode(%)",
  "t1222_Avg_SD":"Avg.(mmol/L)±SD",
  "t1222_Target_Range":"Target Range(%)",
  "t1222_Above_Range":"Above Range(%)",
  "t1222_Below_Range":"Below Range(%)",
  "t1222_Auto_Mode_Exits":"# of Auto Mode Exits",
  "t1221_Auto_Mode":"Auto Mode",
  "t1222_auto_basal":"Auto Basal",
  "t1222_auto_bolus":"Auto Bolus",
  "t0805_User_Management":"Gestão de Usuários",
  "t0805_Patient_Management":"Gestão de Pacientes",
  "t0805_Operation_History":"Histórico de Operação",
  "t0805_User_List":"Lista de usuários",
  "t0805_User":"Do utilizador",
  "t0805_Time":"Tempo",
  "t0805_Operation_Type":"Tipo de operação",
  "t0805_Back":"Voltar",
  "t0805_Add":"Adicionar",
  "t0805_Delete":"Deletar",
  "t0809_Add_User":"Adicionar usuário",
  "t1028_Pattern_C":"Padrão C",
  "t1028_Pattern_D":"Padrão D",
  "t1029_Auto_meal_bolus":"Auto meal bolus",
  "t1029_Auto_mode_correction_bolus":"Auto mode correction bolus",
  "t1029_Sick":"Sick",
  "t1029_Auto_Mode_Feature":"Auto Mode Feature",
  "t1029_Target_SG":"Target SG",
  "t1029_Auto_Meal_Handling":"Auto Meal Handling",
  "t1029_Total_Daily_Dose":"Total Daily Dose",
  "t1029_Pump_Light":"Pump Light",
  "t1029_Alerts_for_Hypo":"Alerts for Hypo",
  "t1102_Out_of_Range":"Out of Range",
  "t1102_Command_Reminder":"Lembrete de Comando",
  "t1102_Alarms_Alerts_on_APP":"Alarmes & Alertas na Bomba",
  "t1102_Alarms_on_App":"Alarmes na Aplicação",
  "t1102_Alerts_on_App":"Alertas na Aplicação",
  "t1102_Factory_Calibration":"Factory Calibration",
  "t1102_Alerts_for_Low":"Alertas para Níveis Baixos",
  "t1102_Alerts_for_High":"Alertas para Níveis Altos",
  "t1102_Alerts_for_Others":"Outros Alertas",
  "t1102_Adjustment":"Adjustment",
  "t1102_Suggested":"Sugerido",
  "t1103_Glucose":"Glicose",
  "t1103_CGM":"CMG",
  "t1103_Insulin":"Insulina",
  "t1103_Carbs":"Carboidratos",
  "t1103_Exercise":"Exercício",
  "t1103_Min_Max":"Min/Max",
  "t1103_Target_Range":"Target Range",
  "t1103_Overall_Tine_In_Range":"Overall: Time In Range",
  "t1103_Basal":"Basal",
  "t1103_Bolus":"Bolus",
  "t1103_Basal_Bolus":"Basal & Bolus",
  "t1103_Auto_Mode_Time_In_Range":"Auto Mode: Time In Range",
  "t1103_Time_below_range":"Time below range",
  "t1103_Time_above_range":"Time above range",
  "t1103_Time_in_target_range":"Time in target range",
  "t1103_Incorrect_Password":"Senha incorreta, $1 tentativa restante, digite a senha correta.",
  "t1103_Incorrect_locked":"As tentativas falhadas excedem o limite, a conta foi bloqueada. Tente novamente em $1 minutos.",
  "t1104_The_data_is_from":"Dados provenientes da Alicação EasySense ou da Aplicação EasyPatch.",
  "t1104_Privacy_Policy":"Privacy Policy and Terms of Use",
  "t1104_updated_privacy_policy":"We have updated our privacy policy and terms of use. Please read and agree to all terms to continue using EasyView.",
  "t1104_Disagree":"Disagree",
  "t1104_Agree":"Aceitar",
  "t1105_Upload_History":"Histórico de upload",
  "t1105_Delete_Data":"Apagar dados",
  "t1105_Target_Range":"Target Range",
  "t1105_request_to_view_your_data":"$1 pedido para ver seus dados.",
  "t1105_Recent_Updates":"Atualizações recentes",
  "t1108_No_data":"Sem dados",
  "t1108_Pump_Bash_SN":"NS da Bomba Base",
  "t1108_Transmitter_SN":"NS do Transmissor",
  "t1112_Normal_Glucose":"Glicose Normal",
  "t1112_Manual_Bolus_or_Modified_Bolus":"Bolus manual ou bolus modificado",
  "t1112_Auto_Mode_Started":"Auto Mode Started",
  "t1112_Auto_Mode_Exit":"Auto Mode Exit",
  "t1112_Normal_Bolus":"Bolus Normal",
  "t1112_Extended_Bolus":"Bolus O Quadrad",
  "t1112_Combo_Bolus":"Bolus de Onda Dupla",
  "t1112_Carbs":"Carboidratos",
  "t1112_Glucose":"Glicose",
  "t1112_BG":"GS",
  "t1112_Audio":"Áudio",
  "t1112_Tone":"Som",
  "t1112_Audio_Options":"Opções de Áudio",
  "t1112_Weight_Unit":"Unidade De Peso",
  "t1112_Height_Unit":"Unidade De Altura",
  "t1112_Not_available":"Não Disponível",
  "t1112_Number":"Número",
  "t1112_days":"# days",
  "t1112_min":"min",
  "t1113_days":"days",
  "t1215_Security":"Mostrar valor de glicose",
  "t1215_MFA":"Autenticação multifator (MFA)",
  "t1215_Enter_verification_code":"Digite o código de verificação",
  "t1215_Multi_factor_ON":"Multifaktorgodkendelse er TIL. Bekræftelseskoden er blevet sendt til $1 Indsend venligst bekræftelseskode.",
  "t1215_Verification_code_incorrect":"Código de Verificação Incorreto",
  "t1215_Show_Glucose_Value":"Mostrar valor de glicose",
  "t1221_enter_verification_code":"Insira o código de verificação de 6 dígitos enviado para $1.",
  "t1221_Verification_Success":"Verificado com sucesso",
  "t1222_We_will_only_process":"Apenas processaremos os seus dados de saúde através da aplicação/site Medtrum com o seu consentimento. ",
  "t1222_If_you_are_under_years":"Caso seja menor de 16 anos de idade, o seu registo nesta aplicação dependerá do consentimento dos seus pais ou responsáveis legais.",
  "t1221_register_cn":"Assiste-lhe o direito de não fazer upload de qualquer dado do dispositivo para a aplicação. Nesse caso, os dados não estarão acessíveis a outros utilizadores. Se optar por não se registar na aplicação/site Medtrum, o único registo dos seus dados de saúde estará armazenado no dispositivo. ",
  "t1221_register_eu":"Se optar por criar a sua conta Medtrum e aceder à nossa aplicação através dessa mesma conta, os dados de saúde registados na aplicação serão enviados para o nosso servidor europeu, onde serão conservados durante dois anos. Assiste-lhe o direito de não fazer upload de qualquer dado do dispositivo para a aplicação. Nesse caso, os dados não estarão acessíveis a outros utilizadores. Se optar por não se registar na aplicação/site Medtrum, o único registo dos seus dados de saúde estará armazenado no dispositivo.",
  "t1221_register_follow":"Apenas processaremos os seus dados de saúde através da aplicação/site Medtrum com o seu consentimento.",
  "t1222_Terms_of_Use":"os Termos de Uso da Medtrum",
  "t1222_Privacy_Policy":"a Política de Privacidade da Medtrum",
  "t1222_Create_Account":"Criar Conta",
  "t1222_Back":"Voltar",
  "t1222_Verify_your_account":"Verifique sua conta",
  "t1222_please_check_your_account":"Enviaremos um código de verificação para $1, verifique sua conta.",
  "t1222_I_Agree_to":"Eu Aceito $1",
  "t1223_Invalid_Verification_Code":"Código de verificação inválido. Por favor, tente novamente.",
}

//export default {poMessages}



// WEBPACK FOOTER //
// ./src/lang/po.js